import { LOTE_SELECTED_ID, LOTE_GET, LOTE_PHOTO_GET, UNIDADE_LIST, UNIDADE_INNER_LIST, CONFIG_ESTATISTICA_GET, RESET } from '../actions/Events';

export default function (state = {}, action) {
  switch (action.type) {

    case LOTE_SELECTED_ID: 
      return { ...state, loteSelectedId: action.payload }
      
    case UNIDADE_LIST:
      return { ...state, results: action.payload }

    case UNIDADE_INNER_LIST:
      return { ...state, innerResults: action.payload }

    case LOTE_GET:
      return { ...state, current: action.payload }

    case LOTE_PHOTO_GET:
      return { ...state, photos: action.payload }

    case CONFIG_ESTATISTICA_GET:
      return { ...state, configEstatistica: action.payload }

    case RESET:
      return {}

    default:
      return state
  }
}

